import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../services/cloudchipr.api";

export const getSchedulesThunk = createAsyncThunk(
  "schedules/getSchedules",
  async (forceRefetch: boolean | undefined, { dispatch }) => {
    const { getV2UsersMeSchedules } = cloudChiprApi.endpoints;

    return await dispatch(
      getV2UsersMeSchedules.initiate({}, { forceRefetch: forceRefetch }),
    ).unwrap();
  },
);
